import React, { useState, useEffect } from 'react';
import style from './FlipCard.module.css';

function FlipCard({ frontContent, backContent }) {
  const [isFlipped, setIsFlipped] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [showHint, setShowHint] = useState(true);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowHint(false); // 5초 후 힌트 애니메이션 중단
  //   }, 5000);
  //   return () => clearTimeout(timer);
  // }, []);

  const handleClick = () => {
    if (!isDisabled) {
      setIsFlipped(!isFlipped);
      setIsDisabled(true);
      setShowHint(false);

      setTimeout(() => {
        setIsDisabled(false);
      }, 1000);
    }
  };

  return (
    <div className={style.container}>
      <div
        className={`${style.flipper} ${isFlipped ? style.flipped : ''}`}
        onPointerUp={handleClick}
      >
        <div
          className={`${style.cardFace} ${style.front} ${
            showHint ? style.hintAnimation : ''
          }`}
        >
          {frontContent}
        </div>
        <div className={`${style.cardFace} ${style.back}`}>
          {backContent}
        </div>
      </div>
    </div>
  );
}

export default FlipCard;
